class SidecartGamification {
    constructor() {
        this.sidecartSelector = "#cart-drawer > div > div";
        this.gamificationSelector = ".js-gamification-container";
        this.cartTotal = null
        this.giftsAdded = new Set()
    }

    initGamification() {
        this.insertGamification();
        this.updateOnFormsSubmit();
    }

    disableGiftsInCart() {
        const giftsInCart = Array.from(this.giftsAdded)

        giftsInCart.forEach(giftItem => {
            // disable quantity controls from gifts
            const cartItem = document.querySelector(`#cart-drawer a[href*="${giftItem}"]`)?.closest('[data-test-id="cart-container"]')

            const quantityControls = cartItem?.lastChild?.lastChild?.firstChild
            const quantityBtns = quantityControls?.querySelectorAll('button')
            const removeButton = cartItem?.lastChild?.lastChild?.lastChild?.firstChild
            if( removeButton ){
                removeButton.style.display = 'none';
            }
            if (quantityControls) quantityControls.style.pointerEvents = "none"
            quantityBtns?.forEach(btn => btn.style.opacity = 0)
        })
    }

    sortGIfts () {
        const giftsInCart = Array.from(this.giftsAdded)

        giftsInCart.forEach((giftItem, index) => {
            const cartItem = document.querySelector(`#cart-drawer a[href*="${giftItem}"]`)?.closest('[data-test-id="cart-container"]')
            cartItem.style.order = index + 1
        })
    }

    observegiftsInCart() {

        const drawer = document.querySelector('#cart-drawer form');
        if (drawer.getAttribute('observing-gifts')) return;

        const config = { childList: true, subtree: true };
        const observer = new MutationObserver((mutationsList) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    this.disableGiftsInCart();
                }
            }
        });
        drawer.setAttribute('observing-gifts', true);
        observer.observe(drawer, config);
    }


    updateOnFormsSubmit() {
        const gamification = this;
    
        // Intercepta XHR de forma segura
        const originalSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function (...args) {
            this.addEventListener('load', function () {
                try {
                    const url = this.responseURL;
                    if (url.includes('/cart') && this.responseType === '' || this.responseType === 'text') {
                        const cart = JSON.parse(this.responseText);
                        gamification.refreshGamification(cart);
                    }
                } catch (e) {
                    null;
                }
            });
            return originalSend.apply(this, args);
        };
    
        // Intercepta fetch de forma segura
        const originalFetch = window.fetch;
        window.fetch = function (...args) {
            const [url] = args;
            return originalFetch(...args).then(async response => {
                try {
                    if (url.includes('/cart')) {
                        const cloned = response.clone();
                        const json = await cloned.json();
                        gamification.refreshGamification(json);
                    }
                } catch (e) {
                    null;
                }
                return response;
            });
        };
    }

    async insertGamification() {
        try{
          const gamificationComponent = (await dgf_wai_elms(this.gamificationSelector))[0];
          const sidecartHeader = (await dgf_wai_elms(this.sidecartSelector))[0];
  
          if (sidecartHeader) {
              this.goals = Array.from(gamificationComponent.querySelectorAll(".js-gamification-goal"))
              this.title = gamificationComponent.querySelector(".js-gamification-title")
              this.progressBar = gamificationComponent.querySelector(".js-gamification-progress")
              sidecartHeader.appendChild(gamificationComponent);
          }        
        } catch(e){ null; }
    }

    updateSidecart() {
        const cartUpdatedEvent = new CustomEvent('THEME:CART_UPDATED');
        window.dispatchEvent(cartUpdatedEvent);
    }

    checkAddedGifts(cart) {
        const cartItems = cart.items.map((item, index) => ({ ...item, line: index }))
        const giftItems = window.goals.map(goal => goal.gift)
        const giftsInCart = cartItems
            .filter(item => giftItems.includes(String(item.variant_id)))

        giftsInCart.forEach(giftItem => {
            // if gift is in cart, add it to the set
            this.giftsAdded.add(String(giftItem.variant_id))
        });

        this.observegiftsInCart();

    }

    async addGift(cart) {

        if (!window.goals) return
        this.checkAddedGifts(cart);
        // check if a goal with a gift was met
        const giftsToAdd = window.goals
            .filter(goal => goal.threshold <= this.cartTotal)
            .map(goal => goal.gift)
            .filter(gift => !this.giftsAdded.has(gift))
            .filter(Boolean);

        const giftsToRemove = window.goals
            .filter(goal => goal.threshold > this.cartTotal)
            .map(goal => goal.gift)
            .filter(gift => this.giftsAdded.has(gift))
            .filter(Boolean);

        if (!(giftsToAdd && giftsToAdd.length) && !(giftsToRemove && giftsToRemove.length)) return

        const giftItems = giftsToAdd.map((giftVariantId) => {
            return {
                'id': giftVariantId,
                'quantity': 1
            }
        })

        let formDataToAdd = {
            'items': giftItems
        };
        let formDataToRemove = {}
        giftsToRemove.forEach(gift => {
            formDataToRemove[gift] = 0
        })

        try {
            if (giftItems && giftItems.length) {
                giftsToAdd.forEach(gift => this.giftsAdded.add(String(gift)))
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formDataToAdd)
                }).then(response => {
                    this.updateSidecart();
                    return response.json();
                }).catch(_ => {
                    giftsToAdd.forEach(gift => this.giftsAdded.delete(String(gift)))
                })
            }

            if (giftsToRemove && giftsToRemove.length) {
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ updates: formDataToRemove })
                }).then(_ => {
                    giftsToRemove.forEach(gift => this.giftsAdded.delete(String(gift)))
                    this.updateSidecart();
                }).catch(_ => {
                    giftsToRemove.forEach(gift => this.giftsAdded.add(String(gift)))
                })
            }

        } catch (err) {
            null;
        }
    }

    progressvalueByInterpolation(value) {
        if (value === 0) return 0
        const goals = window.goals
        if (goals.length == 1) return value

        const thresholds = goals.map(goal => goal.threshold)
        let nextGoal
        let previousGoal

        thresholds.forEach((threshold, index) => {
            const intervalStart = thresholds[index - 1] || 0
            const intervalEnd = threshold

            if (value > intervalStart && value <= intervalEnd) {
                nextGoal = goals[index]
                previousGoal = index > 0 && goals[index - 1]
            }
        })

        const lastGoal = goals[goals.length - 1]
        if (!nextGoal) nextGoal = lastGoal

        const x1 = previousGoal?.threshold || 0
        const x2 = nextGoal.threshold
        const y1 = lastGoal.threshold * (previousGoal?.index) / (goals.length - 1) || 0
        let y2 = lastGoal.threshold * (nextGoal.index) / (goals.length - 1)
        if (y2 === 0) y2 = 0.1 * lastGoal.threshold

        const progress = (y1 * (value - x2) / (x1 - x2)) + (y2 * (value - x1) / (x2 - x1))

        return progress
    }

    refreshGamification(cart) {
        // Get cart total
        const cartTotalInLocalCurr = cart.total_price / 100
        const customerCurrency = cart.currency
        this.cartTotal = Currency.convert(cartTotalInLocalCurr, customerCurrency, "USD")

        if (!window.goals || isNaN(cartTotalInLocalCurr)) return

        this.checkAddedGifts(cart);

        // Update gamification title
        const title = document.getElementById('gamification-title')
        const nextGoal = window.goals.find(goal => goal.threshold > this.cartTotal) || window.goals[window.goals.length - 1]
        const nextGoalTitle = nextGoal?.title
        const article = nextGoal.is_singular_countable_noun ? "a" : ""
        const amountToGoal = (nextGoal.threshold - this.cartTotal)
        const amountToGoalConverted = amountToGoal && Currency.convert(amountToGoal, "USD", customerCurrency)?.toFixed?.(0) * 100

        let newTitle
        if (amountToGoal > 0) newTitle = `You're <span>${formatPrice(amountToGoalConverted)}</span> from ${article} <span class="bold-gamification">${nextGoalTitle}</span>`;
        else newTitle = `You get <span class="bold-gamification">${nextGoalTitle}</span>`

        title.innerHTML = newTitle;
        // Upte progress bar
        const progressBar = document.getElementById("gamification-progress")

        const maxProgress = window.goals[window.goals.length - 1].threshold
        progressBar.max = maxProgress;
        const progressvalue = this.progressvalueByInterpolation(this.cartTotal);
        progressBar.value = progressvalue && progressvalue.toFixed(2) || 0;

        window.goals?.forEach(goal => {
            // Update goal status
            const goalelement = document.getElementById(`goal-${goal.id}`);
            if (!goalelement) return
            // update goal title
            const goalTitle = goalelement.querySelector('.goal-title')
            const goalAchieved = goal.threshold < this.cartTotal

            const amountTocurrentGoalConverted = Currency.convert(goal.threshold, "USD", customerCurrency)?.toFixed(0) * 100
            goalTitle.innerHTML = `<div class="bold-gamification">${isNaN(amountTocurrentGoalConverted) ? "" : formatPrice(amountTocurrentGoalConverted) }</div> <span>${goal.title}</span>`

            if (goalAchieved) {
                goalelement.classList.add("achieved");
            } else {
                goalelement.classList.remove("achieved");
            }
        })

        this.addGift(cart);
        this.sortGIfts();

    }
}

const sidecartGamification = new SidecartGamification();
sidecartGamification.initGamification();